export const departmentOptions = [
  { value: '연구개발', label: '연구개발' },
  { value: '사업관리', label: '사업관리' },
  { value: 'AI센터', label: 'AI센터' },
  { value: '인사관', label: '인사관' },
  { value: '재무/회계', label: '재무/회계' },
  { value: '마케팅팀', label: '마케팅팀' },
];

export const jobOptions = [
  { value: '기획', label: '기획' },
  { value: '전산', label: '전산' },
  { value: '영업', label: '영업' },
  { value: '생산', label: '생산' },
  { value: '개발', label: '개발' },
  { value: '디자인', label: '디자인' },
  { value: '인사', label: '인사' },
  { value: '재무회계', label: '재무회계' },
  { value: '마케팅', label: '마케팅' },
  { value: '구매', label: '구매' },
  { value: '관리', label: '관리' },
];

export const positionOptions = [
  { value: 'J001', label: '사원' },
  { value: 'J002', label: '주임' },
  { value: 'J003', label: '대리' },
  { value: 'J004', label: '과장' },
  { value: 'J005', label: '차장' },
  { value: 'J006', label: '부장' },
  { value: 'J007', label: '이사' },
  { value: 'J008', label: '부사장' },
  { value: 'J009', label: '사장' },
];

export const ranks = {
  J001: "사원",
  J002: "주임",
  J003: "대리",
  J004: "과장",
  J005: "차장",
  J006: "부장",
  J007: "이사",
  J008: "부사장",
  J009: "사장",
};
